
//Data imports
import AccessMatrix from "@/router/access-matrix";
//View and component imports
import Title_Counter from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Counter.vue";
import Title_Department from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Department.vue";
import Title_Project from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Project.vue";
import RouteListItem_Settings from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_Settings.vue";
//const IsProd = (process.env.NODE_ENV === 'production');
//import PlannedConstruction from "@/views/landingpages/PlannedConstruction.vue";
const OldGuiFrame = () => import('@/views/landingpages/OldGuiFrame.vue')
const HeaderCardPage = () => import("@/components/Sections/Containers/HeaderCardsContainer.vue");
const AdminPage = () => import("@/views/admin/AdminPage.vue");
//departments goup
const AdminDepartmentList = () => import("@/views/admin/departments/AdminDepartmentList.vue");
const ViewDepartmentContainer = () => import("@/views/admin/departments/ViewDepartmentContainer.vue");
const ViewDepartmentInfo = () => import("@/views/admin/departments/ViewDepartmentInfo.vue");

//settings goup
const EmailSettings = () => import('@/views/admin/settings/Settings.vue')
const EmailSetting = () => import('@/views/admin/settings/email/EmailSetting.vue');
const CompanySettings = () => import('@/views/admin/settings/companysettings/CompanySettingsPage.vue');
const DefaultSettings = () => import('@/views/admin/settings/default-settings/DefaultSettings.vue');

//jobs 
const JobStatuses = () => import("@/views/admin/jobs/JobStatuses.vue");

//features goup
const FeatureList = () => import("@/views/admin/features/FeatureList.vue");
//accounts goup
const MixedAccountList = () => import("@/views/admin/accounts/MixedAccountList.vue");
const DepartmentAccountList = () => import("@/views/admin/accounts/DepartmentAccountList.vue");
//inventory goup
const Inventory = () => import("@/views/admin/InventoryPage.vue");
//const InventoryMovements = () => import('@/views/admin/InventoryMovementsPage.vue')
//code goup
const AdminFailureCodes = () => import("@/views/admin/machines/AdminFailureCodes.vue");
const AdminRepairCodes = () => import("@/views/admin/machines/AdminRepairCodes.vue");
//warranty types goup
const AdminWarrantyTypeList = () => import("@/views/admin/warrantytype/AdminWarrantyTypeList.vue");
//repair place goup
const AdminRepairPlaceList = () => import("@/views/admin/repairplace/AdminRepairPlaceList.vue");
//asset types goup
const AdminAssetTypeList = () => import("@/views/admin/AdminAssetTypeList.vue");
//projects goup
const AdminProjectsList = () => import("@/views/admin/projects/AdminProjectsList.vue");
const ViewProjectContainer = () => import("@/views/admin/projects/ViewProjectContainer.vue");
const ViewProjectInfo = () => import("@/views/admin/projects/ViewProjectInfo.vue");
//counters goup
const AdminCounterList = () => import("@/views/admin/counters/AdminCounterList.vue");
const ViewCounterContainer = () => import("@/views/admin/counters/ViewCounterContainer.vue");
const ViewCounterInfo = () => import("@/views/admin/counters/ViewCounterInfo.vue");
//leads goup
const AdminLeads = () => import("@/views/admin/leads/AdminLeadList.vue");
const AdminLeadTypes = () => import("@/views/admin/leads/LeadTypesPage.vue");
const LeadEmailSetting = () => import("@/views/admin/leads/LeadEmailSetting.vue");
//checklists goup
const AdminCheckLists = () => import("@/views/admin/checklists/AdminCheckLists.vue");
const EditCheckList = () => import("@/views/admin/checklists/EditCheckList.vue");
//Logs
const EventLogList = () => import("@/views/admin/logging/EventLogList.vue");
const MailLogList = () => import("@/views/admin/logging/MailLogList.vue");
const SmsLogList = () => import("@/views/admin/logging/SmsLogList.vue");
const TaskLogList = () => import("@/views/admin/logging/TaskLogList.vue");
//import/export
const Export = () => import('@/views/admin/Export.vue');
const Import = OldGuiFrame;

//Export item
const trunk = {
  meta: {
    authorize: AccessMatrix.AdminTrunk.module,
    display: { key: "servicesystem.pages.page_titles.admin" },
    icon: "$admin"
  },
  name: "Admin",
  redirect: { name: "AdminHome" },
  path: "/admin",
  component: AdminPage,
  children: [
    {
      //header card page
      meta: {
        authorize: AccessMatrix.AdminTrunk.module,
        display: { key: "servicesystem.pages.page_titles.admin" },
        icon: "$admin",
        overrides: {
          sidebar: false,
          headercard: false
        }
      },
      path: "",
      name: "AdminHome",
      component: HeaderCardPage
    },

    {
      meta: {
        authorize: AccessMatrix.AdminTrunk.module,
        display: { key: "servicesystem.pages.page_titles.admin_settings" },
        icon: "$global_settings",
        overrides: {
          headercard: false
        }
      },
      path: "settings",
      name: "Settings",
      redirect: { name: "SettingsHome" },
      component: AdminPage,
      children: [
        {
          //header card page
          meta: {
            authorize: AccessMatrix.AdminTrunk.module,
            icon: "$global_settings",
            overrides: {
              sidebar: false,
              headercard: false
            }
          },
          path: "",
          name: "SettingsHome",
          component: HeaderCardPage
        },

        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.settings,
            display: { key: "servicesystem.pages.page_titles.company_settings" },
            icon: "mdi-account-supervisor-circle"
          },
          path: "companysettings",
          name: "CompanySettings",
          component: CompanySettings
        },
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.settings,
            display: { key: "servicesystem.pages.page_titles.email_settings" },
            icon: "mdi-email-edit",
          },
          path: "email-settings",
          name: "EmailSettings",
          component: EmailSettings,
          redirect: {
            name: "EditEmailSetting",
            params: { key: "newjob" },
            query: { group: "Job", emailEnabledSettingName: "", emailSubjectSettingName: "NewJobEmailSubject", emailbodySettingName: "NewJobEmailBody", titleText: 'New job' }
          },
          children: [
            {
              meta: {
                authorize: AccessMatrix.AdminTrunk.settings,
                display: { key: "Edit email template" },
                icon: "mdi-email-newsletter",
                overrides: {
                  sidebar: RouteListItem_Settings,
                }
              },
              path: "email/:key",
              name: "EditEmailSetting",
              component: EmailSetting,
            },
          ]
        },
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.settings,
            display: { key: "Default settings" },
            icon: "mdi-table-settings"
          },
          path: "default-settings",
          name: "DefaultSettings",
          component: DefaultSettings
        },
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.accounts_branch,
            displayName: "Features",
            icon: "mdi-feather"
          },
          path: "features",
          name: "Features",
          component: FeatureList
        },
      ],
    },
    {
      meta: {
        authorize: AccessMatrix.AdminTrunk.accounts_branch,
        display: { key: "servicesystem.pages.page_titles.admin_accounts" },
        icon: "$accounts",
        overrides: {
          header: {
            buttons: ["NewAccountBtn"]
          }
        }
      },
      path: "accounts",
      name: "Accounts",
      component: MixedAccountList,
      children: [
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.accounts_branch,
            display: { key: "servicesystem.common_objects.user_types.admins" },
            icon: "$administrator",
            overrides: {
              header: {
                buttons: ["NewAccountBtn"]
              }
            }
          },
          path: "admins",
          name: "AAccounts"
        },
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.accounts_branch,
            display: { key: "servicesystem.common_objects.user_types.technicians" },
            icon: "$technician",
            overrides: {
              header: {
                buttons: ["NewAccountBtn"]
              }
            }
          },
          path: "technicians",
          name: "TAccounts"
        },
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.accounts_branch,
            display: { key: "servicesystem.common_objects.user_types.subcontractors" },
            icon: "$subcontractor",
            overrides: {
              header: {
                buttons: ["NewAccountBtn"]
              }
            }
          },
          path: "sub-contractors",
          name: "SCAccounts"
        },
        {
          meta: {
            licenceEnabled: "PartnerPortal",
            authorize: AccessMatrix.AdminTrunk.accounts_branch,
            display: { key: "servicesystem.common_objects.user_types.partners" },
            icon: "$partner",
            overrides: {
              header: {
                buttons: ["NewAccountBtn"]
              }
            }
          },
          path: "partners",
          name: "PAccounts"
        },
        {
          meta: {
            licenceEnabled: "CustomerPortal",
            authorize: AccessMatrix.AdminTrunk.accounts_branch,
            display: { key: "servicesystem.pages.page_titles.admin_accounts_customers" },
            icon: "$customer_manager",
            overrides: {
              header: {
                buttons: ["NewAccountBtn"]
              }
            }
          },
          path: "customer",
          name: "CAccounts"
        }
      ]
    },
    {
      meta: {
        authorize: AccessMatrix.AdminTrunk.departments,
        display: { key: "servicesystem.pages.page_titles.admin_departments" },
        icon: "$department",
        overrides: {
          header: {
            buttons: ["NewDialogTriggerBtn"]
          }
        }
      },
      path: "departments",
      name: "Departments",
      component: AdminDepartmentList,
      children: [
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.departments,
            overrides: {
              sidebar: false,
              headercard: false,
              title: Title_Department,
            },
            contextMenu: true,
          },
          path: ":departmentId",
          name: "ViewDepartment",
          component: ViewDepartmentContainer,
          redirect: { name: "ViewDepartmentInfo" },
          children: [
            {
              meta: {
                authorize: AccessMatrix.AdminTrunk.departments,
                displayName: "Info",
                icon: "mdi-home"
              },
              path: "info",
              name: "ViewDepartmentInfo",
              component: ViewDepartmentInfo
            },
            {
              meta: {
                authorize: AccessMatrix.AdminTrunk.departments,
                display: { key: "servicesystem.pages.page_titles.admin_accounts" },
                icon: "$accounts",
                overrides: {
                  header: {
                    buttons: ['NewAccountBtn'],
                  },
                }
              },
              name: 'DepartmentUsers',
              path: 'users/:userId?',
              component: DepartmentAccountList,
            },
          ]
        }
      ]
    },
    {
      meta: {
        featureEnabled: "ProjectsEnabled",
        authorize: AccessMatrix.AdminTrunk.machines_branch,
        display: { key: "servicesystem.pages.page_titles.admin_projects" },
        icon: "mdi-folder-pound",
        overrides: {
          header: {
            buttons: ["NewAssetTypeBtn"]
          }
        }
      },
      path: "projects",
      name: "Projects",
      component: AdminProjectsList,
      children: [
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.machines_branch,
            overrides: {
              sidebar: false,
              headercard: false,
              title: Title_Project,
            },
            contextMenu: true,
          },
          path: ":projectId",
          name: "ViewProject",
          component: ViewProjectContainer,
          redirect: { name: "ViewProjectInfo" },
          children: [
            {
              meta: {
                authorize: AccessMatrix.AdminTrunk.machines_branch,
                displayName: "Info",
                icon: "mdi-home"
              },
              path: "info",
              name: "ViewProjectInfo",
              component: ViewProjectInfo
            },
          ]
        }
      ]
    },
    {
      meta: {
        authorize: AccessMatrix.AdminTrunk.jobs_branch,
        display: { key: "servicesystem.pages.page_titles.admin_job_statuses" },
        icon: "$job_statuses"
      },
      path: "job-statuses",
      name: "JobStatuses",
      component: JobStatuses
    },
    {
      meta: {
        authorize: AccessMatrix.AdminTrunk.machines_branch,
        display: { key: "servicesystem.pages.page_titles.admin_machines_inventory" },
        icon: "mdi-bookshelf"
      },
      path: "inventory",
      name: "Inventory",
      component: Inventory
    },
    {
      meta: {
        authorize: AccessMatrix.AdminTrunk.machines_branch,
        display: { key: "servicesystem.pages.page_titles.admin_machines_counters" },
        icon: "$counter",
        overrides: {
          header: {
            buttons: ["NewDialogTriggerBtn"]
          }
        }
      },
      path: "counters",
      name: "Counters",
      component: AdminCounterList,
      children: [
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.machines_branch,
            overrides: {
              sidebar: false,
              headercard: false,
              title: Title_Counter,
            },
            contextMenu: "Hidden"
          },
          path: ":counterId",
          name: "ViewCounter",
          component: ViewCounterContainer,
          redirect: { name: "ViewCounterInfo" },
          children: [
            {
              meta: {
                authorize: AccessMatrix.AdminTrunk.machines_branch,
                displayName: "Info",
                icon: "mdi-home"
              },
              path: "info",
              name: "ViewCounterInfo",
              component: ViewCounterInfo
            }
          ]
        }
      ]
    },
    {
      meta: {
        authorize: AccessMatrix.AdminTrunk.machines_branch,
        display: { key: "servicesystem.pages.page_titles.admin_machines_failure_codes" },
        icon: "$supplier_failure_code",
        overrides: {
          header: {
            buttons: ["NewSupplierFailureCodeBtn"]
          }
        }
      },
      path: "failure-codes",
      name: "FailureCodes",
      component: AdminFailureCodes
    },
    {
      meta: {
        authorize: AccessMatrix.AdminTrunk.machines_branch,
        display: { key: "servicesystem.pages.page_titles.admin_machines_repair_codes" },
        icon: "$repair_code",
        overrides: {
          header: {
            buttons: ["NewDialogTriggerBtn"]
          }
        }
      },
      path: "repair-codes",
      name: "RepairCodes",
      component: AdminRepairCodes
    },
    {
      meta: {
        authorize: AccessMatrix.AdminTrunk.machines_branch,
        display: { key: "servicesystem.common_objects.warranty_type.warranty_types" },
        icon: "$warranty_type",
        overrides: {
          header: {
            buttons: ["NewAssetTypeBtn"]
          }
        }
      },
      path: "warranty-types",
      name: "WarrantyTypes",
      component: AdminWarrantyTypeList
    },
   
    {
      meta: {
        authorize: AccessMatrix.AdminTrunk.machines_branch,
        display: { key: "servicesystem.common_objects.repair_place.repair_places" },
        icon: "$repair_place",
        overrides: {
          header: {
            buttons: ["NewDialogTriggerBtn"]
          }
        }
      },
      path: "repair-places",
      name: "RepairPlaces",
      component: AdminRepairPlaceList
    },
    {
      meta: {
        featureEnabled: "AssetTypesEnabled",
        authorize: AccessMatrix.AdminTrunk.machines_branch,
        display: { key: "servicesystem.pages.page_titles.admin_asset_types" },
        icon: "$asset_type",
        overrides: {
          header: {
            buttons: ["NewAssetTypeBtn"]
          }
        }
      },
      path: "asset-types",
      name: "AssetTypes",
      component: AdminAssetTypeList
    },
    {
      meta: {
        featureEnabled: "LeadsEnabled",
        authorize: AccessMatrix.AdminTrunk.accounts_branch,
        display: { key: "servicesystem.pages.page_titles.admin_leads" },
        icon: "$lead"
      },
      path: "lead",
      redirect: { name: "LeadList" },
      name: "Lead",
      component: AdminPage,
      children: [
        {
          meta: {
            featureEnabled: "LeadsEnabled",
            authorize: AccessMatrix.AdminTrunk.accounts_branch,
            display: { key: "servicesystem.pages.page_titles.admin_lead_list" },
            icon: "mdi-brightness-percent",
            overrides: {
              header: {
                buttons: ["NewLeadBtn"]
              }
            }
          },
          path: "list",
          name: "LeadList",
          component: AdminLeads
        },
        {
          meta: {
            featureEnabled: "LeadsEnabled",
            authorize: AccessMatrix.AdminTrunk.accounts_branch,
            display: { key: "servicesystem.pages.page_titles.admin_lead_types" },
            icon: "mdi-brightness-auto",
            overrides: {
              header: {
                buttons: ["NewLeadTypeBtn"]
              }
            }
          },
          path: "types",
          name: "LeadTypes",
          component: AdminLeadTypes
        },
        {
          meta: {
            featureEnabled: "LeadsEnabled",
            authorize: AccessMatrix.AdminTrunk.accounts_branch,
            display: { key: "servicesystem.pages.page_titles.admin_lead_email" },
            icon: "mdi-email-edit",
          },
          name: 'LeadEmail',
          path: 'email',
          component: LeadEmailSetting,
        },
      ]
    },
    {
      meta: {
        authorize: AccessMatrix.AdminTrunk.accounts_branch,
        display: { key: "servicesystem.pages.page_titles.admin_logs" },
        icon: "mdi-waves"
      },
      path: "logs",
      redirect: { name: "EventLogs" },
      name: "Logs",
      component: AdminPage,
      children: [
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.machines_branch,
            display: { key: "servicesystem.pages.page_titles.admin_event_logs" },
            icon: "mdi-clipboard-pulse"
          },
          path: "events",
          name: "EventLogs",
          component: EventLogList
        },
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.machines_branch,
            display: { key: "servicesystem.pages.page_titles.admin_mail_logs" },
            icon: "mdi-mailbox-open-up"
          },
          path: "mail",
          name: "MailLogs",
          component: MailLogList
        },
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.machines_branch,
            display: { key: "servicesystem.pages.page_titles.admin_sms_logs" },
            icon: "mdi-message-processing"
          },
          path: "sms",
          name: "SmsLogs",
          component: SmsLogList
        },
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.machines_branch,
            display: { key: "servicesystem.pages.page_titles.admin_task_logs" },
            icon: "mdi-stack-overflow"
          },
          path: "task",
          name: "TaskLogs",
          component: TaskLogList
        }
      ]
    },
    {
      meta: {
        authorize: AccessMatrix.AdminTrunk.machines_branch,
        display: { key: "servicesystem.pages.page_titles.admin_import_export" },
        icon: "mdi-database-sync",
        contextMenu: true,
      },
      path: 'import-export',
      name: 'ImportExport',
      redirect: { name: 'Export' },
      component: AdminPage,
      children: [
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.machines_branch,
            display: { key:"servicesystem.pages.page_titles.admin_export" },
            icon: "mdi-database-export"
          },
          path: 'export',
          name: 'Export',
          component: Export,
        },
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.machines_branch,
            display: { key: "servicesystem.pages.page_titles.admin_import" },
            icon: "mdi-database-import-outline"
          },
          path: 'import',
          name: 'Import',
          component: Import
        },
      ]
    },
    {
      meta: {
        licenceEnabled: "CheckLists",
        authorize: AccessMatrix.AdminTrunk.checklists_branch,
        displayName: "Checklists",
        icon: "$repair_code",
        overrides: {}
      },
      path: "check-lists",
      name: "Checklists",
      component: AdminCheckLists
    },
    {
      meta: {
        licenceEnabled: "CheckLists",
        authorize: AccessMatrix.AdminTrunk.checklists_branch,
        displayName: "EditChecklists",
        icon: "$repair_code",
        overrides: {
          sidebar: false,
          headercard: false
        }
      },
      path: "check-lists/edit/:templateId?",
      name: "EditCheckList",
      component: EditCheckList
    }
  ]
};
export default trunk;
